<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 手机号码
            label: '手机号码',
            value: 'billId',
            type: 'input',
            placeholder: '请输入手机号码',
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'operatorName',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 油卡余额
            label: '油卡余额',
            value: 'stroil',
            type: 'inputrange',
            placeholder: '请输入油卡余额',
          },
          { // 应收逾期
            label: '应收逾期',
            value: 'receivableOverdueBalanceStr',
            type: 'inputrange',
            placeholder: '请输入应收逾期',
          },
          { // 应付逾期
            label: '应付逾期',
            value: 'payableOverdueBalanceStr',
            type: 'inputrange',
            placeholder: '请输入应付逾期',
          },
          { // 未到期资金
            label: '未到期资金',
            value: 'strmargin',
            type: 'inputrange',
            placeholder: '请输入未到期资金',
          },
          { // ETC余额
            label: 'ETC余额',
            value: 'stretc',
            type: 'inputrange',
            placeholder: '请输入ETC余额',
          },
          { // 账户状态
            label: '账户状态',
            value: 'accState',
            type: 'select',
            default: -1,
            placeholder: '请选择账户状态',
            options: [
              {
                label: '全部',
                value: -1,
              },
              {
                label: '无效',
                value: 0,
              },
              {
                label: '有效',
                value: 1,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 油卡余额
      if (searchBoxData.stroil) {
        searchBoxData.stroilBegin = searchBoxData.stroil[0];
        searchBoxData.stroilEnd = searchBoxData.stroil[1];
        delete searchBoxData.stroil;
      }
      // 应收逾期
      if (searchBoxData.receivableOverdueBalanceStr) {
        searchBoxData.receivableOverdueBalanceBeginStr = searchBoxData.receivableOverdueBalanceStr[0];
        searchBoxData.receivableOverdueBalanceEndStr = searchBoxData.receivableOverdueBalanceStr[1];
        delete searchBoxData.receivableOverdueBalanceStr;
      }
      // 应付逾期
      if (searchBoxData.payableOverdueBalanceStr) {
        searchBoxData.payableOverdueBalanceBeginStr = searchBoxData.payableOverdueBalanceStr[0];
        searchBoxData.payableOverdueBalanceEndStr = searchBoxData.payableOverdueBalanceStr[1];
        delete searchBoxData.payableOverdueBalanceStr;
      }
      // 未到期资金
      if (searchBoxData.strmargin) {
        searchBoxData.strmarginBegin = searchBoxData.strmargin[0];
        searchBoxData.strmarginEnd = searchBoxData.strmargin[1];
        delete searchBoxData.strmargin;
      }
      // ETC余额
      if (searchBoxData.stretc) {
        searchBoxData.stretcBegin = searchBoxData.stretc[0];
        searchBoxData.stretcEnd = searchBoxData.stretc[1];
        delete searchBoxData.stretc;
      }
      // 油卡余额
      if (searchBoxData.stretc) {
        searchBoxData.stretcBegin = searchBoxData.stretc[0];
        searchBoxData.stretcEnd = searchBoxData.stretc[1];
        delete searchBoxData.stretc;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
